function parallaxMouse() {
	if ($('#parallax-tomato-left').length) {
		let scene = document.getElementById('parallax-tomato-left');
		new Parallax(scene);
	}

	if ($('#parallax-tomato-right').length) {
		let scene = document.getElementById('parallax-tomato-right');
		new Parallax(scene);
	}

	if ($('#parallax-pepper').length) {
		let scene = document.getElementById('parallax-pepper');
		new Parallax(scene);
	}
}

$(document).ready(function(e) {
	parallaxMouse();
});